import React from "react";
import { Button, Tooltip, OverlayTrigger } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import { TemplateRuleRow } from "../../RulesModal.types";

interface ActionBtnsCellRendererProps {
  data: TemplateRuleRow;
  onEdit: (row: TemplateRuleRow) => void;
  onDelete: (row: TemplateRuleRow) => void;
}

const ActionBtnsCellRenderer: React.FC<ActionBtnsCellRendererProps> = ({ data, onEdit, onDelete }) => {
  const handleEditClick = () => {
    onEdit(data);
  };

  const handleDeleteClick = () => {
    onDelete(data);
  };

  return (
    <div style={{ display: "flex" }}>
      <OverlayTrigger placement="bottom" overlay={<Tooltip>Edit rule</Tooltip>}>
        <Button className="icon-button" onClick={handleEditClick}>
          <Icon.PencilSquare />
        </Button>
      </OverlayTrigger>
      <OverlayTrigger placement="bottom" overlay={<Tooltip>Delete rule</Tooltip>}>
        <Button className="icon-button" onClick={handleDeleteClick}>
          <Icon.Trash style={{ color: "red" }} />
        </Button>
      </OverlayTrigger>
    </div>
  );
};

export default ActionBtnsCellRenderer;
